

























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import { UpdateStockDto } from "@/store/entities/gift-info-config";
import Ajax from "@/lib/ajax";

@Component
export default class UpdateStockVM extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ required: true }) editModel: any;

  loading: boolean = false;

  updateInput: UpdateStockDto = new UpdateStockDto();

  async save() {
    if (!this.updateInput.id) {
      this.notice("请刷新后重试");
      return;
    }

    this.loading = true;

    await Ajax.post(
      "/api/services/app/GiftInfoConfig/UpdateStock",
      this.updateInput
    );

    this.loading = false;

    this.$emit("save-success");
    this.$emit("input", false);
  }

  cancel() {
    this.$emit("input", false);
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      let model = new UpdateStockDto();
      model.id = this.editModel.id;
      model.probability = this.editModel.probability;
      model.commonStockId = this.editModel.commonStockId;
      model.remark = this.editModel.remark;
      model.amount = this.editModel.amount;
      model.sendNum = this.editModel.sendNum;

      this.updateInput = model;
    }
  }

  notice(msg) {
    this.$Notice.info({
      title: "提示",
      desc: msg,
    });
  }
}
